export const PushNotificationBellTestIds = {
  BELL: 'push-notification.bell-button',
  DRAWER: 'push-notification.drawer',
};
